import { render } from "./NewRecordDonationForm.vue?vue&type=template&id=61b07d78"
import script from "./NewRecordDonationForm.vue?vue&type=script&lang=js"
export * from "./NewRecordDonationForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__